import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/service/api-service/api-service';
import { API } from '../../core/API';
import { PageSummary, Page, PageVariable, SavePagePayload, PageVariablesResponse, ApiResponse } from './content-manager.interfaces';

@Injectable({ providedIn: 'root' })
export class DynamicContentAdminService {
  constructor(private api: ApiService) {}

  getAllPages(): Observable<ApiResponse<PageSummary[]>> {
    return this.api.get(API.CONTENT_MANAGER.GET_ALL_PAGES);
  }

  getPagesTree(): Observable<ApiResponse<Page[]>> {
    return this.api.get(API.PAGES.GET_ALL);
  }

  getPageVariables(pageCode: string): Observable<PageVariablesResponse> {
    return this.api.get(`${API.CONTENT_MANAGER.GET_BY_PAGE}/${pageCode}`);
  }

  getVariableById(id: number): Observable<ApiResponse<PageVariable>> {
    return this.api.get(`${API.CONTENT_MANAGER.GET_BY_ID}/${id}`);
  }

  savePage(payload: SavePagePayload): Observable<ApiResponse<any>> {
    return this.api.put(API.CONTENT_MANAGER.SAVE_PAGE, payload);
  }

  updatePageFlags(pageId: number, flags: Record<string, never>): Observable<ApiResponse<any>> {
    return this.api.put(`${API.PAGES.UPDATE_FLAGS}/${pageId}/flags`, flags);
  }
}
